import { createFileRoute } from '@tanstack/react-router';
import { useHasPermission } from '@/hooks/usePermissions';
import { WebhookSubscriptionsPanel } from '@/components/organisms/settings-webhooks/WebhookSubscriptionsPanel';
import { PartnerApiSettingsShell } from '@/components/organisms/settings-partner-api/PartnerApiSettingsShell';

export const Route = createFileRoute('/_dashboard/dashboard/settings/partner-api/webhooks')({
  component: PartnerApiWebhooksRoute,
});

function PartnerApiWebhooksRoute() {
  const canView = useHasPermission('company:view');

  if (!canView) {
    return (
      <div className="max-w-2xl rounded-md border border-amber-200 bg-amber-50 p-6 text-sm text-amber-900">
        You don&apos;t have permission to manage webhooks. Ask an administrator for access.
      </div>
    );
  }

  return (
    <PartnerApiSettingsShell activeTab="webhooks" contentClassName="flex overflow-hidden">
      <WebhookSubscriptionsPanel embedded surface="partner" />
    </PartnerApiSettingsShell>
  );
}
